import { BackTop, Col, Divider, Row, Space, Typography } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { getUniqueId } from "../../../../../common/common";
import { useUserContextHook } from "../../../../../hooks/useUserContextHook";
import {
  CountryEnum,
  Employee,
  UserEnum,
  isAccessible,
} from "../../../../../utils/app-common";
import { useManifestContextHook } from "./Context/useManifestContextHook";
import EditComponent from "./EditComponent";
import FileUploadComponent from "./FileUploadComponent";
import ManifestCountryComponent from "./ManifestCountryComponent";

const ManifestationComponentLoadable = React.lazy(
  () => import("./ManifestationComponent")
);
const ManifestBillingInformationComponentLoadable = React.lazy(
  () => import("./ManifestBillingInformationComponent")
);
const ManifestShipmentDetailsComponentLoadable = React.lazy(
  () => import("./ManifestShipmentDetailsComponent")
);

const ContentComponent = () => {
  const { employeeDetail } = useUserContextHook() || {};
  const [isOpen, setIsOpen] = useState(false);

  const { isOracleInvoiced, sentForOracleInvoicing, fromOperation, readOnly } =
    useManifestContextHook();
  const isAccessToEdit = [
    UserEnum.MANIFESTER,
    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
    UserEnum.OPERATION_SUPERVISOR,
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
    UserEnum.MANAGER,
    UserEnum.OPS_MANAGER,
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
  ].includes(employeeDetail?.positionId!);

  const isAccessToEditByEmployeeId = isAccessible(
    [Employee.HAJJAJ, Employee.IMATHUL_RAFI_KSA],
    [CountryEnum.KSA],
    true
  );
  return (
    <>
      <BackTop className="back-to-top" />
      <Content style={{ backgroundColor: "white", padding: "1.5rem" }}>
        <Row gutter={50} align="middle">
          <Col>
            <Space hidden={!fromOperation}>
              <Typography.Title level={5}>
                Billing Information:
              </Typography.Title>
              {isAccessToEdit || isAccessToEditByEmployeeId ? (
                <span hidden={isOracleInvoiced || sentForOracleInvoicing}>
                  <AiOutlineEdit
                    size={16}
                    onClick={() => setIsOpen((prv) => !prv)}
                    className="cursor-pointer"
                  />
                </span>
              ) : null}
            </Space>
            <Row gutter={12}>
              <ManifestBillingInformationComponentLoadable
                key={getUniqueId()}
              />
            </Row>
          </Col>
          <Divider type="vertical" style={{ height: "20rem" }} />
          <Col>
            <Row>
              <Typography.Title level={5}>Shipment Details:</Typography.Title>
            </Row>
            <Row>
              <ManifestShipmentDetailsComponentLoadable key={getUniqueId()} />
            </Row>
          </Col>
          <Divider type="vertical" style={{ height: "20rem" }} />
          <Col>
            <Row>
              <Typography.Title level={5}>Country:</Typography.Title>
            </Row>
            <Row>
              <ManifestCountryComponent key={getUniqueId()} />
            </Row>
          </Col>
          <Divider />
        </Row>
        <Typography.Title level={5}>Domestic Charge:</Typography.Title>
        <ManifestationComponentLoadable key={getUniqueId()} />
        <Divider />
        <Row hidden={!fromOperation || readOnly}>
          <FileUploadComponent />
        </Row>
        {isOpen ? (
          <EditComponent isOpen={isOpen} setIsOpen={() => setIsOpen(false)} />
        ) : null}
      </Content>
    </>
  );
};

export default ContentComponent;
